import axios from "axios";
import { IAssessmentTest } from "@/modules/assessments/types/test.interface";
import { httpClient } from "../http";
import isValidationFailureResponse from "@/shared/utils/comparison/isValidationFailureResponse";
import { ValidationFailureResponse } from "@/shared/interfaces/validation-error.interface";

export interface INorm {
  normId: number;
  version: number;
  name: string;
  description: string;
  numberOfCases: number;
  testId: number;
  distributionMode: NormDistributionModeEnum;
  populationSize: number | null;
  clientId: number | null;
  createdBy: number | null;
  createdAt?: string;
  updatedAt?: string;
  assessments?: number;
  assessmentTests?: IAssessmentTest[];
  assessmentsDone?: number;
}

export interface INormSummary {
  testId: number;
  normId: number;
  name: string;
}

export interface NormUploadCreatedResult {
  testName: string;
  normName: string;
  scaleCount: number;
}

export interface NormUploadSuccessResponse {
  success: true;
  created: NormUploadCreatedResult[];
  totalRecords: number;
}

export type NormUploadResult = NormUploadSuccessResponse | ValidationFailureResponse;

export enum NormDistributionModeEnum {
  NORMAL = "normal",
  NOT_NORMAL = "not_normal",
}

export class NormsHttpService {
  static async getTestNorms(testId: number): Promise<INorm[]> {
    const { data: norms } = await httpClient.get(`/api/tests/${testId}/norms`);

    return norms;
  }

  static async uploadNorms(file: File): Promise<NormUploadResult> {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const { data } = await httpClient.post(`/api/tests/norms/upload`, formData);
      return data;
    } catch (error: unknown) {
      if (
        axios.isAxiosError(error) &&
        error.response?.status === 400 &&
        isValidationFailureResponse(error.response.data)
      ) {
        return error.response.data;
      }
      throw error;
    }
  }
}
